import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  EnvelopeIcon,
  ExternalLinkAltIcon
} from "@patternfly/react-icons";

import {
  pedagogue,
  pedagoguePoster,
  preventionDocuments,
  schoolGuides,
  selfStudyDocuments,
  helpDocuments,
  pedagogueTasks
} from "./data/pedagogueData";

const DocumentsList = ({ documents }) => (
  <Content>
    <List isPlain>
      {documents.map((document) => (
        <ListItem key={document.id}>
          <a
            href={document.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {document.title}{" "}
            <ExternalLinkAltIcon />
          </a>
        </ListItem>
      ))}
    </List>
  </Content>
);

const PedagoguePage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={10}
              offset={1}
              md={8}
              mdOffset={2}
            >
              <Stack hasGutter>
                <StackItem>
                  <Content
                    component="h1"
                    style={{ textAlign: "center" }}
                  >
                    Pedagog
                  </Content>
                </StackItem>

                <StackItem>
                  <Content
                    component="p"
                    style={{ textAlign: "center" }}
                  >
                    Pomoc psychologiczno-pedagogiczna,
                    materiały oraz informacje dla uczniów
                    i rodziców.
                  </Content>
                </StackItem>
              </Stack>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardBody>
                  <Stack hasGutter>
                    <StackItem>
                      <Content
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        {pedagogue.role}
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Content
                        component="p"
                        style={{ textAlign: "center" }}
                      >
                        {pedagogue.name}
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Content
                        component="p"
                        style={{ textAlign: "center" }}
                      >
                        <Content component="a" href={`mailto:${pedagogue.email}`}>
                          <EnvelopeIcon />{" "}
                          {pedagogue.email}
                        </Content>
                      </Content>
                    </StackItem>
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
            <Grid>
                <GridItem
                span={12}
                md={8}
                mdOffset={2}
            >
                <Grid hasGutter>
                    {/* LEWA KOLUMNA */}
                    <GridItem span={12} lg={7}>
                    <Stack hasGutter>
                        <StackItem>
                        <Card isGlass>
                            <CardTitle>
                            Poradniki dla szkół
                            </CardTitle>

                            <CardBody>
                            <DocumentsList documents={schoolGuides} />
                            </CardBody>
                        </Card>
                        </StackItem>

                        <StackItem>
                        <Card isGlass>
                            <CardTitle>
                            Samokształcenie - Materiały
                            </CardTitle>

                            <CardBody>
                            <DocumentsList
                                documents={selfStudyDocuments}
                            />
                            </CardBody>
                        </Card>
                        </StackItem>

                        <StackItem>
                        <Card isGlass>
                            <CardTitle>
                            Pomoc
                            </CardTitle>

                            <CardBody>
                            <DocumentsList documents={helpDocuments} />
                            </CardBody>
                        </Card>
                        </StackItem>
                    </Stack>
                    </GridItem>

                    {/* PRAWA KOLUMNA */}
                <GridItem span={12} lg={5}>
                <Card isGlass isFullHeight>
                    <CardBody>
                    <Stack hasGutter>
                        <StackItem>
                        <img
                            src={pedagoguePoster.src}
                            alt={pedagoguePoster.alt}
                            loading="lazy"
                            style={{
                            display: "block",
                            width: "100%",
                            height: "auto"
                            }}
                        />
                        </StackItem>

                        <StackItem>
                        <DocumentsList
                            documents={preventionDocuments}
                        />
                        </StackItem>
                    </Stack>
                    </CardBody>
                </Card>
                </GridItem>
        </Grid>
        </GridItem>
        </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardTitle>
                  Zadania pedagoga szkolnego
                </CardTitle>

                <CardBody>
                  <List component="ol">
                    {pedagogueTasks.map((task, index) => (
                      <ListItem key={index}>
                        {task}
                      </ListItem>
                    ))}
                  </List>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default PedagoguePage;